function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function MobileIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M17 1H7C5.3457 1 4 2.3457 4 4V20C4 21.6543 5.3457 23 7 23H17C18.6543 23 20 21.6543 20 20V4C20 2.3457 18.6543 1 17 1ZM18 20C18 20.5518 17.5513 21 17 21H7C6.44873 21 6 20.5518 6 20V4C6 3.44824 6.44873 3 7 3H17C17.5513 3 18 3.44824 18 4V20ZM9 4H15V6H9V4Z",
    fill: "currentColor"
  }));
}
export function MobileIconSmall(props) {
  return ___EmotionJSX(MobileIcon, _extends({
    size: "small"
  }, props));
}